import { propEq, anyPass, allPass } from 'ramda';
import { CASINO_LEADER_BOARD_RACES_LIST } from '../CasinoLeaderBoard/RacesList/constants';
import { CASINO_LEADER_BOARD_SLIDER } from '../CasinoLeaderBoard/Slider/constants';
import { registrationStatuses, statuses, RACE_RULE_STATUSES, RACE_RULES_TRIGGER_TYPE } from './constants';

export const isRegInProgress = propEq('registrationStatus', registrationStatuses.IN_PROGRESS);
export const isInternalBoard = propEq('registrationStatus', registrationStatuses.INTERNAL);
export const isRegNotStarted = propEq('registrationStatus', registrationStatuses.NOT_STARTED);
export const isPlayerJoined = propEq('joined', true);
export const isRaceActive = propEq('status', statuses.ACTIVE);
export const isRaceNotStarted = propEq('status', statuses.NOT_STARTED);
export const isRaceCompleted = propEq('status', statuses.COMPLETED);
export const isRacePending = propEq('status', statuses.PENDING_REVIEW);

export const isRaceAvailable = allPass([
    anyPass([isRaceActive, isRaceNotStarted]),
    anyPass([isPlayerJoined, isRegInProgress, isRegNotStarted, isInternalBoard])
]);

export const isPendingRaceAvailable = allPass([isRacePending, isPlayerJoined]);

export const isJoinButtonAvailable = anyPass([isPlayerJoined, isRegInProgress, isRegNotStarted]);

export const startingFirst = (race, nextRace) =>
    new Date(race.leaderboardStartTime) - new Date(nextRace.leaderboardStartTime);

export const endingFirst = (race, nextRace) =>
    new Date(race.leaderboardEndTime) - new Date(nextRace.leaderboardEndTime);

export const onAirFirst = (race, nextRace) =>
    (nextRace.status === statuses.ACTIVE) - (race.status === statuses.ACTIVE);

export const upcomingFirst = (race, nextRace) =>
    (nextRace.status === statuses.NOT_STARTED) - (race.status === statuses.NOT_STARTED);

export const joinedFirst = (race, nextRace) =>
    nextRace.joined - race.joined;

export const endRegistrationFirst = (race, nextRace) =>
    new Date(race.registrationEndTime) - new Date(nextRace.registrationEndTime);

export const startRegistrationFirst = (race, nextRace) =>
    new Date(race.registrationStartTime) - new Date(nextRace.registrationStartTime);

export const isLeaderBoardEligible = portletType => (leaderBoard) => {
    if (portletType === CASINO_LEADER_BOARD_SLIDER) {
        return isRaceAvailable(leaderBoard);
    } else if (portletType === CASINO_LEADER_BOARD_RACES_LIST) {
        return anyPass([isRaceCompleted, isRaceAvailable, isPendingRaceAvailable])(leaderBoard);
    }

    return false;
};

export const isGameRoundRule = propEq('triggerType', RACE_RULES_TRIGGER_TYPE);
export const isCompletedRule = propEq('status', RACE_RULE_STATUSES.completed);

export const byRuleStatus = (rule, nextRule) =>
    (rule.status === RACE_RULE_STATUSES.approved) - (nextRule.status === RACE_RULE_STATUSES.approved);

export const byRuleDate = (rule, nextRule) => {
    if (rule.endDateTime === nextRule.endDateTime) {
        return new Date(rule.startDateTime) - new Date(nextRule.startDateTime);
    }

    return new Date(rule.endDateTime) - new Date(nextRule.endDateTime);
};
